import { forwardRef, useCallback, type RefObject } from 'react';
import { StyledGridMessageListContainer, StyledGridDateGroup, StyledMessageListScrollSpacer } from './styles';
import { useMessageListScroll } from './hooks/useMessageListScroll';
import MessageCard from '../MessageCard';
import { type MessageListProps } from './types';
import { type Message } from '../MessageCard/types';
import Divider from '../../Divider';
const groupMessagesByDate = (messages: Message[]): Record<string, Message[]> => {
  const groupedMessages: Partial<Record<string, Message[]>> = {};
  messages.forEach(message => {
    const date = message.createdAt.toISOString().split('T')[0];
    groupedMessages[date] ??= [];
    groupedMessages[date]?.push(message);
  });
  return groupedMessages as Record<string, Message[]>;
};
export const MessageList = forwardRef<HTMLDivElement, MessageListProps>(({
  messages,
  emptyState,
  loadingCardComponent,
  isLoading,
  autoScrollToBottom = true,
  pinLatestUserMessageToTop = false,
  messageGroupDateFormatter,
  headerComponent
}, ref) => {
  const hasMessages = messages.length > 0;
  const isGroupedByDate = messageGroupDateFormatter != null;
  const {
    containerRef,
    setLastUserMessageRef,
    spacerRef,
    lastUserMessageIndex
  } = useMessageListScroll({
    messages,
    isLoading,
    autoScrollToBottom,
    pinLatestUserMessageToTop
  });
  const shouldShowPinSpacer = pinLatestUserMessageToTop && lastUserMessageIndex >= 0 && !isGroupedByDate;
  const setRefs = useCallback((node: HTMLDivElement | null) => {
    containerRef.current = node;
    if (typeof ref === 'function') {
      ref(node);
    } else if (ref != null) {
      ;
      (ref as RefObject<HTMLDivElement | null>).current = node;
    }
  }, [ref]);
  return <StyledGridMessageListContainer ref={setRefs}>
        {headerComponent != null && headerComponent}
        {hasMessages && <>
            {isGroupedByDate && Object.entries(groupMessagesByDate(messages)).map(([date, groupedMessages]) => <StyledGridDateGroup key={date}>
                  <Divider text={messageGroupDateFormatter(date)} textAlignment="center" />
                  {groupedMessages.map(message => <MessageCard key={message.id} message={message} />)}
                </StyledGridDateGroup>)}
            {!isGroupedByDate && messages.map((message_0, index) => <MessageCard key={message_0.id} message={message_0} ref={index === lastUserMessageIndex ? setLastUserMessageRef : undefined} />)}
            {isLoading === true && loadingCardComponent != null && loadingCardComponent}
            {shouldShowPinSpacer ? <StyledMessageListScrollSpacer ref={spacerRef} aria-hidden /> : null}
          </>}

        {!hasMessages && emptyState}
      </StyledGridMessageListContainer>;
});
export default MessageList;